import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "../api";
import { Button, Card, CardContent, Label, Textarea } from "../components/ui";

const LABELS = {
  FIRST_CALL: "10 minutos antes",
  SECOND_CALL: "5 minutos antes",
  FINAL_CALL: "Na largada",
};

export default function Templates() {
  const [drafts, setDrafts] = useState({});
  const load = async () => {
    try { const r = await api.get("/templates"); setDrafts(r.data); } catch { }
  };
  useEffect(() => { load(); }, []);

  const save = async (t) => {
    try { await api.put(`/templates/${t}`, { template: drafts[t] }); toast.success("Template salvo"); load(); }
    catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div className="max-w-3xl">
      <h1 className="font-display text-4xl uppercase leading-none mb-6">Templates de Mensagem</h1>
      <Card>
        <CardContent className="p-6 space-y-6">
          <div className="text-xs text-gray-400">
            Variáveis: <code className="text-[hsl(var(--primary))]">{"{nomes}"}</code>, <code className="text-[hsl(var(--primary))]">{"{horario}"}</code>, <code className="text-[hsl(var(--primary))]">{"{sessao}"}</code>, <code className="text-[hsl(var(--primary))]">{"{pista}"}</code>, <code className="text-[hsl(var(--primary))]">{"{quantidade_pilotos}"}</code>
          </div>
          {["FIRST_CALL", "SECOND_CALL", "FINAL_CALL"].map((t) => (
            <div key={t} className="space-y-2">
              <Label>{LABELS[t]} <span className="text-gray-500 lowercase">— {t}</span></Label>
              <Textarea
                data-testid={`tpl-${t}`}
                rows={3}
                value={drafts[t] || ""}
                onChange={(e) => setDrafts((d) => ({ ...d, [t]: e.target.value }))}
              />
              <Button data-testid={`tpl-save-${t}`} size="sm" variant="outline" onClick={() => save(t)}>Salvar</Button>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
